import moment from "moment";
import { DATE_FORMAT } from "src/config";

const parseDate = (arg, format = null) => {
  if (!arg) return "-";
  const parsed = moment(arg);
  return parsed.isValid() ? parsed.format(format || DATE_FORMAT) : "-";
};

export default parseDate;
